var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "load-more" }, [
    !_vm.isCompleted()
      ? _c(
          "div",
          {
            staticClass: "load-more-badge",
            class: { loading: _vm.isLoading() },
            on: { click: _vm.loadMore },
          },
          [
            !_vm.isLoading()
              ? _c("i", { staticClass: "material-icons arrow-icon" }, [
                  _vm._v("expand_less"),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isLoading()
              ? _c(
                  "i",
                  { staticClass: "material-icons loading-icon rotating" },
                  [_vm._v("autorenew")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("span", { staticClass: "badge-text" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.isLoading()
                      ? _vm.$t("auto.loading")
                      : _vm.$t("auto.loadMore")
                  ) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "badge-count" }, [
              _vm._v(
                _vm._s(
                  _vm.$t("chart.loadMoreMessagesProgress", {
                    current: _vm.totalReceived(),
                    total: _vm.history().totalCount,
                  })
                )
              ),
            ]),
          ]
        )
      : _c("div", { staticClass: "load-more-badge completed" }, [
          _c("i", { staticClass: "material-icons completed-icon" }, [
            _vm._v("done"),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "badge-text" }, [
            _vm._v(_vm._s(_vm.$t("message.allHistoryLoaded"))),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "badge-count" }, [
            _vm._v(
              _vm._s(
                _vm.$t("chart.loadMoreMessagesTotal", {
                  total: _vm.history().totalCount,
                })
              )
            ),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }